import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router'
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import {VideoMessageBase} from '../base/videoMessage';
import { VideoMessageAdminAPI } from '../../services/admin/videoMessageAdminAPI';
import { AccountAdminAPI } from '../../services/admin/accountAdminAPI';
import { EnvironmentService } from '../../services/environmentService';

@inject(AuthService, UserMessageService, Router, VideoMessageAdminAPI, AccountAdminAPI, EnvironmentService)
export class VideoMessage extends VideoMessageBase {
    constructor(authService, userMessageService, router, api, accountApi, envService) {
        super(authService, userMessageService, router, "api/admin", api, accountApi, envService, true);
        this.fileBase = null;
        this.awsCheck = false;
        this.email = null;
    }
    activate(params, route) {

        super.activate(params, route);
        if(!params.id && params.account_owner_id) {
            this.account_owner_user_id = params.account_owner_id;
        }

        if(this.id) {
            this.api.getFileList(
                this.id, 
                this.authService.getUser().token,
                this.getFileListSuccess.bind(this),
                this.saveLoadError.bind(this));
        }
        
    }

    reset() {
       

        this.accountApi.getUserData(
            this.account_owner_user_id,  
            this.authService.getUser().token, 
            (userData) => {
                this.account_org_phone = userData.account.org_phone;
                this.account_org_email = userData.account.org_email;
                this.account_website = userData.account.website;
                super.reset();
            }, 
            this.saveLoadError.bind(this));
    }

    load(processingWait = false) {
        super.load(processingWait);
        if(processingWait) {
            this.api.getFileList(
                this.id, 
                this.authService.getUser().token,
                this.getFileListSuccess.bind(this),
                this.saveLoadError.bind(this));
        }

    }

    setData(data) {
        super.setData(data);
      
        this.accountApi.getUserData(
            this.account_owner_user_id,  
            this.authService.getUser().token, 
            (userData) => {
                this.account_org_phone = userData.account.org_phone;
                this.account_org_email = userData.account.org_email;
                this.account_website = userData.account.website;
                this.email = userData.user.email;
            }, 
            this.saveLoadError.bind(this));

        this.api.getFileList(
            this.id, 
            this.authService.getUser().token,
            this.getFileListSuccess.bind(this),
            this.saveLoadError.bind(this));

       
    }

    reproduce(setReady = false) {
        this.saving = true;
        var data = this.getData();
        data.set_ready = setReady;
        this.api.reproduce(
            data,
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }

    getFileListSuccess(files) {

        if(files.bucket) {

            this.fileBase = "https://" + files.bucket + ".s3.amazonaws.com/";
            this.files = files.files;
            this.awsCheck = true;

        }

        else {
            
            this.files = files;
            this.awsCheck = false;
            this.fileBase = "api/admin/videoMessage/downloadFile/" + this.id;
       
        }

    }

}
